import { CropYear } from "../../cropYear"
import { createIndex } from "../../utils/array"
import { isArray } from "../../utils/utils"
import { checkPerennialSequence } from "../autohistory"
import { getPerennialCroppingInfo } from "../perennial"
import { DomItem } from "./domItem"
import { CroppingHistoryProvider } from "./history"

export function setupPerennialCrops(items: DomItem[], history: CroppingHistoryProvider): DomItem[] {

    const perennial = items.filter(i => i.vm.crop && i.vm.crop.Perennial)

    const sequences = findSequences(perennial, history)

    const groups = sequences.map(s => ({ values: s }))

    setupGroups(groups)

    return items

}


function findSequences(perennial: DomItem[], history: CroppingHistoryProvider) {

    const { getNext, getPrev } = getRelationships(perennial, history)

    const roots = findRoots(perennial)

    const sequences = roots.map(r => findSequence(r)).filter(s => isArray(s) && (s.length > 1))

    return sequences

    function findRoots(items: DomItem[]) {

        const isRoot = (i: DomItem) => !checkSequence(getPrev(i), i)

        return items.filter(isRoot)

    }

    function findSequence(node: DomItem) {

        const sequence = []

        while (node) {

            sequence.push(node)

            const next = getSingle(getNext(node))
            if (!next) break;
            if (!checkSequence(node, next)) break

            node = next

        }

        return sequence

    }

    function checkSequence(prevList: DomItem | DomItem[], nextList: DomItem | DomItem[]) {

        return checkPerennialSequence(prevList, nextList, i => getPerennialCroppingInfo(i.vm.cropping))


    }

    function getSingle(a: DomItem | DomItem[]) {

        return (a instanceof DomItem)
            ? a
            : isArray(a) && (a.length == 1)
                ? a[0]
                : null

    }

    function getRelationships(items: DomItem[], history: CroppingHistoryProvider) {

        const index = createIndex(perennial, i => i.vm.croppingId)
        const getItems = (ids: number[]) => (ids || []).map(id => index[id]).filter(c => !!c)
        const getNext = (i: DomItem) => getItems(i.vm.cropping.NextIds)
        const getPrev = (i: DomItem) => getItems(i.vm.cropping.PreviousIds)

        return {
            getNext,
            getPrev
        }
    }

}

function setupGroups(groups: {
    values: DomItem[]
}[]) {

    groups.forEach(g => {

        let crops = g.values;
        let start = Math.min.apply(Math, crops.map(c => c.vm.cropping.YearId));
        let end = Math.max.apply(Math, crops.map(c => c.vm.cropping.YearId));

        crops.forEach(c => {

            let y = new CropYear(c.vm.cropping.YearId);

            switch (y.YearId) {

                case start:
                    c.endDate = y.EndDate;
                    c.continuousNext = true;
                    break;

                case end:
                    c.startDate = y.StartDate;
                    c.continuousPrev = true;
                    break;

                default:
                    c.continuousNext = true;
                    c.continuousPrev = true;
                    c.endDate = y.EndDate;
                    c.startDate = y.StartDate;
                    break;
            }


        })

    })

}
